// TODO:
// ADD LIGHTBOX
class MainProductSliderWithThumbnails extends HTMLElement {
  constructor() {
    super();
    this.variantSelector = document.querySelector("variant-selects");
    this.slideCustomEvent = null;
  }

  connectedCallback() {
    this.loadMainSliderElements();
    this.loadThumbnailsElements();
    this.buildSlider();
    this.enableDesktopZoom();

    document.addEventListener(
      "product:variant-change",
      this.variantChangeEventHandler.bind(this)
    );

    this.scrollBtn?.addEventListener("click", () => {
      this.thumbnailContainer.scrollTop = this.thumbnailContainer.scrollHeight;
    });
  }

  disconnectedCallback() {
    this.thumbnailContainer.removeEventListener(
      "click",
      this.thumbnailEventHandler.bind(this)
    );
  }

  loadMainSliderElements() {
    this.mainSliderElement = this.querySelector(
      "#slider-with-thumbnails--main-slider"
    );

    this.mainSliderSlides = Array.from(
      this.mainSliderElement.querySelectorAll(".slider-with-thumbnails--slide")
    );

    const defaultActiveVariant = this.mainSliderElement.querySelector(
      `[data-is-image-for-active-variant="true"]`
    );
    defaultActiveVariant.parentElement.prepend(defaultActiveVariant);

    this.mainSliderElement.addEventListener("click", (event) => {
      const slide = event.target.closest(".slider-with-thumbnails--slide");
      if (!slide) return;
      const { mainSlideId } = slide.dataset;
      this.zoomSlide(mainSlideId);
    });

    this.querySelector("#main-slider--zoom-icon").addEventListener(
      "click",
      () => {
        const slide = this.mainSliderElement.querySelector(
          ".slider-with-thumbnails--slide.is-selected"
        );
        if (!slide) return;
        const { mainSlideId } = slide.dataset;
        this.zoomSlide(mainSlideId);
      }
    );
  }

  loadThumbnailsElements() {
    this.thumbnailContainer = this.querySelector(
      "#slider-with-thumbnails--thumbnails"
    );

    this.thumbnailContainer.addEventListener(
      "click",
      this.thumbnailEventHandler.bind(this)
    );

    const defaultActiveVariant = this.thumbnailContainer.querySelector(
      `[data-thumbnail-active="true"]`
    );
    defaultActiveVariant.parentElement.prepend(defaultActiveVariant);

    this.scrollBtn = this.querySelector(
      "#slider-with-thumbnails--thumbnails-scroll-btn"
    );
  }

  async variantChangeEventHandler(event) {
    const variantAlt = event.detail.variant.featured_image.alt.toLowerCase();
    this.filterMainSlider(variantAlt);
    this.filterThumbnails(variantAlt);
  }

  thumbnailEventHandler(event) {
    const thumbnail = event.target.closest(".thumbnail");
    if (!thumbnail) return;

    const { thumbnailId } = thumbnail.dataset;

    const filteredSlides = Array.from(
      this.mainSliderElement.querySelectorAll(
        ".slider-with-thumbnails--slide.filtered-slide"
      )
    );

    const mainSliderSlide = this.mainSliderElement.querySelector(
      `[data-main-slide-id="${thumbnailId}"]`
    );

    const mainSliderSlideIndex = filteredSlides.indexOf(mainSliderSlide);

    const prevActiveThumbnail = this.thumbnailContainer.querySelector(
      `.thumbnail[data-thumbnail-active="true"]`
    );

    prevActiveThumbnail.dataset.thumbnailActive = false;

    thumbnail.dataset.thumbnailActive = true;

    this.mainSlider.select(mainSliderSlideIndex);
  }

  filterThumbnails(variantAlt) {
    this.thumbnailContainer.querySelectorAll(".thumbnail").forEach((el) => {
      let { thumbnailAlt } = el.dataset;
      let thumbnailIncludesVariantAlt = thumbnailAlt.includes(variantAlt);
      el.dataset.thumbnailFiltered = thumbnailIncludesVariantAlt;
      el.dataset.thumbnailActive = false;
      if (thumbnailAlt === variantAlt) {
        el.dataset.thumbnailActive = true;
        el.parentElement.prepend(el);
      }
    });

    this.thumbnailContainer.scrollTop = 0;
  }

  filterMainSlider(variantAlt) {
    this.mainSlider.destroy();

    this.mainSliderSlides.forEach((el) => {
      let { mainSlideAlt } = el.dataset;
      let mainSlideIncludesVariantAlt = mainSlideAlt.includes(variantAlt);
      if (mainSlideIncludesVariantAlt) {
        el.classList.add("filtered-slide");
      } else {
        el.classList.remove("filtered-slide");
      }
    });

    this.buildSlider();
  }

  buildSlider() {
    this.mainSlider = new Flickity("#slider-with-thumbnails--main-slider", {
      contain: true,
      pageDots: true,
      cellAlign: "left",
      prevNextButtons: false,
      cellSelector: ".filtered-slide",
      adaptiveHeight: false,
    });
  }

  zoomSlide(mainSlideId) {
    // only enable on mobile
    if (window.innerWidth > 768) return;
    this.slideCustomEvent = new CustomEvent(
      "product-slider-with-thumbnail:slide-clicked",
      {
        detail: {
          mainSlideId,
        },
      }
    );
    window.dispatchEvent(this.slideCustomEvent);
  }
  enableDesktopZoom() {
    // Only enable on desktop
    if (window.innerWidth < 769) return;
    // or use matchMedia if you want a dynamic approach

    // Grab all product__zoom-container elements from your slider area
    const zoomContainers = this.mainSliderElement.querySelectorAll(
      ".slider-with-thumbnails--slide .product__zoom-container"
    );

    // For each container, add event listeners for click & mousemove
    zoomContainers.forEach((container) => {
      // When user clicks, toggle zoom-visible
      container.addEventListener("click", () => {
        container.classList.toggle("zoom-visible");
        // Reset background-position so it doesn’t jump from old position
        container.style.backgroundPosition = "center";
      });

      // Follow cursor only if zoom is active
      container.addEventListener("mousemove", (event) => {
        if (!container.classList.contains("zoom-visible")) return;

        const rect = container.getBoundingClientRect();
        const offsetX = event.clientX - rect.left;
        const offsetY = event.clientY - rect.top;

        const xPercent = (offsetX / rect.width) * 100;
        const yPercent = (offsetY / rect.height) * 100;

        container.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
      });
    });
  }
}

class MainProductSliderWithThumbnailsLightbox extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector(
      "#main-product-slider-with-thumbnails-lightbox-container"
    );

    this.slider = this.querySelector(
      "#main-product-slider-with-thumbnails-lightbox-slider"
    );

    this.closeBtn = this.querySelector(
      "#close-product-slider-with-thumbnails-lightbox"
    );

    this.addEventListener("click", this.componentClickEventHandler.bind(this));

    window.addEventListener(
      "product-slider-with-thumbnail:slide-clicked",
      this.productSlideClickHandler.bind(this)
    );

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.closeLightbox();
      }
    });
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.closeLightbox();
      }
    });
  }

  componentClickEventHandler(event) {
    const closeBtn = event.target.closest(
      "#close-product-slider-with-thumbnails-lightbox"
    );

    const nextSlideBtn = event.target.closest(
      "#next-slide-product-slider-with-thumbnails-lightbox"
    );

    const prevSlideBtn = event.target.closest(
      "#prev-slide-product-slider-with-thumbnails-lightbox"
    );

    if (closeBtn) {
      this.closeLightbox();
      return;
    }

    if (nextSlideBtn) {
      this.scrollSlider("next");
      return;
    }

    if (prevSlideBtn) {
      this.scrollSlider("prev");
      return;
    }

    this.closeLightbox();
  }

  productSlideClickHandler(event) {
    const { mainSlideId } = event.detail;
    this.openLightbox();
    this.scrollSlideIntoView(mainSlideId);
  }

  scrollSlideIntoView(mainSlideId) {
    const lightboxSlide = this.slider.querySelector(
      `.main-product-slider-with-thumbnails-lightbox-slide[data-media-id="${mainSlideId}"]`
    );

    const lightboxSlidePosition =
      lightboxSlide.offsetLeft - this.slider.offsetLeft;

    this.slider.scrollTo({
      left: lightboxSlidePosition,
      behavior: "smooth",
    });
  }

  scrollSlider(action) {
    const refSlide = this.slider.children[0].offsetWidth;

    switch (action) {
      case "next":
        this.slider.scrollBy({ left: refSlide, behavior: "smooth" });
        break;
      case "prev":
        this.slider.scrollBy({ left: -refSlide, behavior: "smooth" });
        break;
      default:
        break;
    }
  }

  openLightbox() {
    this.container.dataset.showProductSliderWithThumbnailsLightbox = true;
  }

  closeLightbox() {
    this.container.dataset.showProductSliderWithThumbnailsLightbox = false;
  }
}

customElements.define(
  "main-product-slider-with-thumbnails",
  MainProductSliderWithThumbnails
);

customElements.define(
  "main-product-slider-with-thumbnails-lightbox",
  MainProductSliderWithThumbnailsLightbox
);
